<template>
    <div class="applybox">
        <headerbox :focus="1"></headerbox>
        <div class="imgsbox">
            <img src="../../public/statics/img/regeist.jpg" alt="">
           <!-- <div class="imfbotfont">
                <p> © 2021 All Rights Reserved 苏州量子方舟网络科技有限公司 版权所有</p>
                <p> 苏ICP备18053448号-2</p>
            </div>-->
        </div>


        <div class="regist">
            <div class="regist1">欢迎3PL物流商加入IDA云物流(
                <span v-if="$route.query.vip_type==1" style="color:#00aec2;">基础版</span>
                <span v-if="$route.query.vip_type==2" style="color:#84c024;">专业版</span>
                <span v-if="$route.query.vip_type==3" style="color:#2693cb;">高级版</span>
                )
            </div>
            <!--            <div class="regist2">欢迎来到IDA运物流，申请注册！</div>-->
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <div class="unit">
                    <div class="units">
                        <span>*</span>
                        <p>手机号</p>
                    </div>
                    <el-form-item prop="phone">
                        <el-input v-model="ruleForm.phone" placeholder="请输入手机号"
                                  style="width: 12rem;height: 0.6rem;"></el-input>
                    </el-form-item>
                </div>
                <div class="unit">
                    <div class="units">
                        <span>*</span>
                        <p>验证码</p>
                    </div>
                    <el-form-item prop="code">
                        <div class="codestyle">
                            <el-input v-model="ruleForm.code" placeholder="请输入验证码" style="width: 9.5rem;"></el-input>
                            <div v-show="shows==true" class="codestyles" @click="keyCodes()">
                                获取验证码
                            </div>
                            <div v-show="shows==false" class="codestyles">
                                {{count}}秒
                            </div>
                        </div>

                    </el-form-item>
                </div>
                <div class="unit">
                    <div class="units">
                        <span>*</span>
                        <p>企业名称</p>
                    </div>
                    <el-form-item prop="company_name">
                        <el-input v-model="ruleForm.company_name" placeholder="请输入企业名称" style="width: 12rem"></el-input>
                    </el-form-item>
                </div>
                <el-form-item>
                    <div class="subs" @click="submitForm('ruleForm')">提交</div>
                </el-form-item>
                <el-form-item>
                    <div class="bots">
                        <div class="bots1">
                            <div class="bots1font" @click="bots1showclick()">我是货主</div>
                            <div class="bots1s" v-show="bots1show" ref="treeWrap1">
                                <img src="../../public/statics/img/yhz_android.jpg" alt="">
                                <img src="../../public/statics/img/yhz_ios.png" alt="">
                                <div class="bots1z"></div>

                            </div>

                        </div>
                        <div class="bots2" style="cursor: auto">|</div>

                        <div class="bots3">
                            <div class="bots3font" @click="bots3showclick()">我是车主</div>
                            <div class="bots3s" v-show="bots3show" ref="treeWrap3">
                                <img src="../../public/statics/img/ywl_android.jpg" alt="">
                                <img src="../../public/statics/img/ywl_ios.png" alt="">
                                <div class="bots1z"></div>
                            </div>

                        </div>
                    </div>

                </el-form-item>

            </el-form>
        </div>


        <!--作废弹窗-->
        <el-dialog :visible.sync="dialogVisible" width="433px" :show-close="false">
            <div slot="title" class="dialog-footer" style="display: flex;align-items: center;">
                <div
                        style="width:4px;
height:16px;
background:rgba(243,89,89,1);
border-radius:60px;margin-right: 5px;"
                ></div>
                <span
                        style="font-size:18px;font-family:PingFang SC;font-weight:400;color:rgba(51,51,51,1);"
                >请选择操作!</span>
            </div>
            <div style="width:100%; display: flex;flex-wrap: wrap;">
                <span style="width:100%;display: flex;justify-content: space-around;">
          <el-button
                  style="width: 132px;height:42px;padding: 0;"
                  type="info"
                  @click="liveweb()"
          >留在官网</el-button>
           <el-button
                   style="width: 132px;height:42px;padding: 0;"
                   type="success"
                   @click="jumpsystem()"
           >进入系统</el-button>
        </span>
            </div>
        </el-dialog>


    </div>

</template>

<script>
    const TIME_COUNT = 60;
    import {auth, anth} from '../request/api';
    import headerbox from "../components/boxtop";

    export default {
        name: "apply",
        components: {
            headerbox
        },
        data() {
            return {
                bots1show: false,
                bots3show: false,
                ruleForm: {
                    phone: "",
                    code: "",
                    company_name: "",
                },
                rules: {
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'},
                    ],
                    code: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                    ],
                    company_name: [
                        {required: true, message: '请输入公司名称', trigger: 'blur'},
                    ],
                },

                shows: true,  // 初始启用按钮
                count: '',   // 初始化次数
                timer: '',

                //弹框
                dialogVisible: false,
            }
        },
        mounted() {
            document.addEventListener('mouseup', (e) => {
                let tree = this.$refs.treeWrap1;
                let tree3 = this.$refs.treeWrap3;
                if (tree) {
                    if (!tree.contains(e.target)) {
                        this.bots1show = false
                    }
                }
                if (tree3) {
                    if (!tree3.contains(e.target)) {
                        this.bots3show = false
                    }
                }
            });

        },
        methods: {
            liveweb() {
                this.dialogVisible = false;
            },
            jumpsystem() {
                window.location.replace(window.idomain);
            },

            bots1showclick() {
                this.bots1show = !this.bots1show;
                this.bots3show = false;
            },
            bots3showclick() {
                this.bots3show = !this.bots3show;
                this.bots1show = false;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let url = "/v1/member/login/register";
                        let data = {
                            phone: this.ruleForm.phone,
                            code: this.ruleForm.code,
                            company_name: this.ruleForm.company_name,
                            vip_type: this.$route.query.vip_type,
                        };
                        auth(url, data).then(res => {
                            if (res.data.code == 1) {
                                this.$message({
                                    type: 'success',
                                    message: '注册成功!',
                                });
                                setTimeout(() => {
                                    this.dialogVisible = true;
                                }, 200)
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.data.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 验证码
            keyCodes() {
                if (this.ruleForm.phone == undefined || this.ruleForm.phone == '') {
                    this.$message({
                        type: "warning",
                        message: "请先输入手机号"
                    })
                } else {
                    if (!this.timer) {
                        let url = "/v1/member/login/send_sms";
                        let data = {
                            phone: this.ruleForm.phone,
                            type: 2
                        };
                        auth(url, data).then(data => {
                                if (data.data.code == 1) {
                                    this.$message({
                                        type: "success",
                                        message: "发送成功"
                                    })
                                    this.count = TIME_COUNT;
                                    this.shows = false;
                                    this.timer = setInterval(() => {
                                        if (this.count > 0 && this.count <= TIME_COUNT) {
                                            this.count--;
                                        } else {
                                            this.shows = true;
                                            clearInterval(this.timer);  // 清除定时器
                                            this.timer = null;
                                        }
                                    }, 1000)
                                } else {
                                    this.$message({
                                        type: "warning",
                                        message: data.data.msg
                                    })
                                }
                            }
                        )
                    }
                }
            },
        },
    }
</script>

<style scoped lang='scss'>
    .applybox {
        width: 100%;
        height: 100vh;
        background: #fff;
        position: relative;

        .imgsbox {
            width: 6.5rem;
            height: 100vh;
            background: #315db0;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                height: auto;
                width:6.5rem;
            }

            .imgfont {
                position: absolute;
                top: 20%;
                width: 5rem;
                left: 0.8rem;
                color: #ffffff;
                font-size: 0.35rem;
                display: flex;
                flex-wrap: wrap;
                text-align: left;
                line-height: 0.5rem;
                text-indent: 2em;
                word-wrap: break-word;
                word-break: break-all;
            }

            .imfbotfont {
                font-size: 0.15rem;
                width: 5rem;
                font-family: "PingFang SC";
                color: #ffffff;
                position: absolute;
                bottom: 0.2rem;
                left: 0;
                right: 0;
                margin: auto;
            }

        }

        .regist {
            position: absolute;
            left: 8rem;
            top: 2rem;
            width: 12rem;
            height: auto;
            background: #fff;
            /*ackground: #42b983;*/

            padding: 0.25rem;
            display: flex;
            flex-wrap: wrap;

            .regist1 {
                width: 100%;
                font-size: 24px;
                font-family: "PingFang SC";
                text-align: left;
                margin-bottom: 10px;

            }

            .regist2 {
                width: 100%;
                font-size: 18px;
                font-family: "PingFang SC";
                text-align: left;
                margin-bottom: 10px;
            }

            .unit {
                display: flex;
                flex-direction: column;
                flex-wrap: wrap;
                margin-bottom: 5px;

                .units {
                    font-size: 14px;
                    font-family: "PingFang SC";
                    line-height: 24px;
                    color: #606266;
                    display: flex;
                    margin-bottom: 5px;

                    span {
                        color: #F35959;
                        margin-right: 5px;
                    }

                    p {
                    }

                }
            }

            .codestyle {
                display: flex;
                justify-content: space-between;

                .codestyles {
                    width: 2rem;
                    height: 0.6rem;
                    line-height: 0.6rem;
                    background: linear-gradient(to bottom right, #4f8aff, #4b60ff);
                    box-shadow: 0px 5px 6px 0px rgba(4, 0, 0, 0.26);
                    border-radius: 6px;
                    cursor: pointer;
                    color: #ffffff;
                }

                .codestyles:active {
                    opacity: 0.9;
                }
            }

            .subs {
                width: 12rem;
                height: 0.6rem;
                line-height: 0.6rem;
                background: linear-gradient(to bottom right, #4f8aff, #4b60ff);
                box-shadow: 0px 5px 6px 0px rgba(4, 0, 0, 0.26);
                border-radius: 6px;
                cursor: pointer;
                color: #ffffff;
            }

            .subs:active {
                opacity: 0.9;

            }

            .bots {
                display: flex;
                justify-content: flex-end;

                .bots1 {
                    position: relative;

                    .bots1font {
                        font-size: 16px;
                        color: #4f8aff;
                        cursor: pointer;
                    }

                    .bots1s {
                        position: absolute;
                        bottom: 0.6rem;
                        left: -3rem;
                        width: 6rem;
                        height: 3rem;
                        background: #003982;
                        border-radius: 4px;
                        box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                        -webkit-box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                        -moz-box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                        display: flex;
                        align-items: center;
                        justify-content: space-around;

                        img {
                            width: 2.5rem;
                            height: 2.5rem;
                            border-radius: 4px;
                        }

                        .bots1z {
                            position: absolute;
                            right: 2.5rem;
                            bottom: -10px;
                            width: 0;
                            height: 0;
                            border-width: 0 10px 10px;
                            border-style: solid;
                            border-color: transparent transparent #003982;;
                            transform: rotate(180deg);
                        }

                    }

                }

                .bots3 {
                    position: relative;

                    .bots3font {
                        font-size: 16px;
                        color: #4f8aff;
                        cursor: pointer;
                    }

                    .bots3s {
                        position: absolute;
                        bottom: 0.6rem;
                        left: -3rem;
                        width: 6rem;
                        height: 3rem;
                        background: #003982;
                        border-radius: 4px;
                        box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                        -webkit-box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                        -moz-box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                        display: flex;
                        align-items: center;
                        justify-content: space-around;

                        img {
                            width: 2.5rem;
                            height: 2.5rem;
                            border-radius: 4px;
                        }

                        .bots1z {
                            position: absolute;
                            right: 2.5rem;
                            bottom: -10px;
                            width: 0;
                            height: 0;
                            border-width: 0 10px 10px;
                            border-style: solid;
                            border-color: transparent transparent #003982;;
                            transform: rotate(180deg);
                        }
                    }
                }

                /*.bots1:active,bots3:active{*/
                /*    opacity: 0.85;*/
                /*}*/
                .bots2 {
                    font-size: 16px;
                    color: #4f8aff;
                    margin: 0 10px;

                }
            }


        }
    }
</style>
<style lang="scss">
    .regist {
        .el-input__inner {
            height: 0.6rem;
        }
    }
</style>
